import React, {Component} from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Grid from '@material-ui/core/Grid';
import {Helmet} from "react-helmet";
import Typography from "@material-ui/core/es/Typography/Typography";
import Helpers from "../Utils/Helpers";
import Card from '@material-ui/core/Card';
import ResponsiveEmbed from "react-responsive-embed";
import Button from "@material-ui/core/Button";

import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    EmailShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    EmailIcon,
} from 'react-share';

import { Link } from "react-router-dom"
import {Settings} from "../Utils/Settings";
import {ReducedButton, SoldButton, PrintButton} from "./Buttons";

class DetailsTrailer extends Component {

    render() {

        const details = this.props.searchDetailsRecord;

        if (!details) {
            return "";
        }

        let overlayCaption = details.overlaycaption[0];
        if (overlayCaption.length > 0) {
            overlayCaption += " ";
        }

        let images = [];
        let firstImage = "";

        for (var index = 1; index <= 30; index++) {
            let image = details["t_xpath" + index][0];
            let thumbnail = details["t_xpathth" + index][0];
            let caption = details["t_com" + index][0];
            if (image && image.length > 0) {
                if (firstImage.length === 0) {
                    firstImage = image;
                }

                images.push({
                    original: image,
                    thumbnail: thumbnail,
                    description: overlayCaption + caption
                });
            }
        }

        let price = null;
        let normalPrice = parseFloat(details.c_price[0]);
        let salePrice = parseFloat(details.c_saleprice[0]);
        if (salePrice === 0) { salePrice = normalPrice;}

        if (normalPrice > 0 && salePrice !== normalPrice) {
            price =
                <Typography variant='h5'>
                    <strike>${Helpers.formatMoney(normalPrice)}</strike> ${Helpers.formatMoney(salePrice)}<br/>
                </Typography>
        } else if (normalPrice > 0) {
            price = <Typography variant='h5'>${Helpers.formatMoney(normalPrice)}<br/></Typography>
        } else {
            price = null;
        }

        let pageTitle = details.c_year[0] + " " + details.c_manu[0] + " " + details.c_model[0];
        let pageCanonicalUrl = details.URL[0];

        let floorplanLink = details.th_xpathfp [0];
        let floorplan = (floorplanLink) ?
            <Typography variant='body1' align={"center"}><Link style={{textDecoration: "none"}} to="{floorplanLink}">View Floorplan</Link></Typography> :
            null;

        let videoUrl = Helpers.getVideoEmbedUrl(details.c_extra7[0]);
        let video = (videoUrl) ?
            <ResponsiveEmbed src={videoUrl} allowFullScreen></ResponsiveEmbed> :
            null;

        let trackingImage = "https://dashboard.equinemediaworld.com/Listing/Impression?lt=" + Settings.inventoryTypes.TRAILER + "&id=" + details.c_id[0];
        let shareUrl = Settings.socialShareUseCanonicalUrls ? pageCanonicalUrl : window.location.href;

        let reducedButton = details.c_r && details.c_r[0] === "R" ?
            <React.Fragment><ReducedButton/><br/></React.Fragment> :
            null;

        let soldButton = details.c_sold_date && details.c_sold_date[0].length > 0 ?
            <React.Fragment><SoldButton/><br/></React.Fragment> :
            null;

        return (
            <div>
                <Grid container spacing={24}>
                    <Helmet>
                        <title>{pageTitle}</title>
                        <link rel="canonical" href={pageCanonicalUrl}/>
                        <meta name="og:url" content={pageCanonicalUrl}/>
                        <meta name="og:image" content={firstImage}/>
                        <meta name="og:type" content="product"/>
                        <meta name="twitter:card" content="summary"/>
                    </Helmet>
                    <Grid item xs={12}>
                        <Link style={{textDecoration: "none"}} to="/search/horse-trailers"><Button style={{marginBottom: "15px"}} variant="contained" color="default">Back</Button></Link>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h1'>{pageTitle}</Typography>
                    </Grid>
                    <Grid item sm={9} xs={12}>
                        <ImageGallery items={images}/>
                        {floorplan}
                    </Grid>
                    <Grid item sm={3} xs={12}>
                        <Card style={{padding: "10px"}}>
                            {price !== null && <React.Fragment>{price}</React.Fragment>} {reducedButton}{soldButton}
                            <Typography variant='body2' style={{lineHeight: 2}}>
                                <strong>Mfg:</strong> {details.c_manu[0]}<br/>
                                <strong>Year:</strong> {details.c_year[0]}<br/>
                                <strong>Horses:</strong> {details.c_horses[0]}<br/>
                                <strong>Model:</strong> {details.c_model[0]}<br/>
                                <strong>New:</strong> {details.c_new[0]}<br/>
                                <strong>Living Quarters:</strong> {details.c_liv[0]}<br/>
                                <strong>Location:</strong> {details.c_con_city[0]}, {details.c_con_st[0]}<br/>
                                <strong>Stock:</strong> {details.c_stock[0]}<br/>
                                {details.c_con_e[0].length > 0 && <React.Fragment><strong>Email:</strong> <a href={"mailto:" + details.c_con_e[0]}>{details.c_con_e[0]}</a><br/></React.Fragment>}
                                {details.c_con_ph[0].length > 0 && <React.Fragment><strong>Phone:</strong> {details.c_con_ph[0]}<br/></React.Fragment>}
                                {details.C_con_phtf[0].length > 0 && <React.Fragment><strong>Toll-Free:</strong> {details.C_con_phtf[0]}<br/></React.Fragment>}
                            </Typography>

                            <FacebookShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><FacebookIcon round size={32} /></FacebookShareButton>
                            <TwitterShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><TwitterIcon round size={32} /></TwitterShareButton>
                            <PinterestShareButton style={{display: "inline-block", marginRight: "10px"}} media={firstImage} url={shareUrl}><PinterestIcon round size={32} /></PinterestShareButton>
                            <EmailShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><EmailIcon round size={32} /></EmailShareButton>

                            <Typography align={"right"}><PrintButton/></Typography>

                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        {video}
                        <Typography variant='body1' dangerouslySetInnerHTML={{__html: Helpers.safeHtml(details.c_description[0])}}></Typography>
                        <Typography variant='h6' color='secondary' style={{marginTop: "20px"}} dangerouslySetInnerHTML={{__html: Helpers.safeHtml(details.c_comment[0])}}></Typography>
                        <img alt="" src={trackingImage} />
                    </Grid>

                </Grid>
            </div>
        )
    }
}

export default (DetailsTrailer);

